import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { RewardProvider } from "../../shared/providers/rewards.provider";
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';
import { RewardTypeModel } from "../../shared/models/rewards";
import { ToastClientService } from "src/app/services/toast/toast-client.service";


@Component({
  selector: 'app-reward-types',
  templateUrl: './reward-types.component.html',
  styleUrls: ['./reward-types.component.scss']
})
export class RewardTypesComponent implements OnInit {
  
  addOrEditRewardType: String;
  rewardTypes: RewardTypeModel[] = [];
  formGroup;
  deletePopupUiData;


  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    public rewardProvider: RewardProvider,
    public adminDataProvider: AdminDataProvider,
    private toast: ToastClientService,
  ) { }

  ngOnInit() {
   }

  ngDoCheck() {
    this.rewardTypes = this.rewardProvider.rewardTypes;
    console.log(this.rewardTypes);
  }

  addRewardType(targetModal) {
    this.addOrEditRewardType = "add";
    this.formGroup = this.fb.group({
      // program_id: 1,
      reward_type_name: new FormControl("", [Validators.required]),
      reward_type_icon: new FormControl("", [Validators.required]),
    });

    this.showRewardTypeModal(targetModal);
  }

  get f() {
    return this.formGroup.controls;
  }

  editRewardType(targetModal, reward) {
    console.log(reward);
    this.addOrEditRewardType = "edit";
    this.formGroup = this.fb.group({
      status: 1,
      id: reward.id,
      reward_type_name: new FormControl(reward.reward_type_name, [Validators.required]),
      reward_type_icon: new FormControl(reward.reward_type_icon, [Validators.required]),
      // program_id: 1,
    });

    this.showRewardTypeModal(targetModal);
  }

  deleteRewardType(targetModal, reward) {
    this.addOrEditRewardType = "delete";
    this.deletePopupUiData = reward.reward_type_name;

    this.formGroup = this.fb.group({
      id: reward.id,
      status: 0,
      // program_id: 1,
    });
    this.showRewardTypeModal(targetModal);
  }

  showRewardTypeModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }

  submitted = false;

  onSubmitRewardType(formData: RewardTypeModel) {
    console.log(formData)
    // return
    this.submitted = true;
    if (this.formGroup.invalid) {
      return;
    }

    
    if (this.addOrEditRewardType == "add") {
      this.rewardProvider.addRewardType(formData);
    } else if (this.addOrEditRewardType == "edit") {
      this.rewardProvider.editRewardType(formData);
    } else if (this.addOrEditRewardType == "delete") {
      this.rewardProvider.deleteRewardType(formData);
    }
    this.modalService.dismissAll();
  }
}

